import React, { Component } from 'react';
import { SideMenu } from '../../Components/AdminSideMenu';
import { connect } from 'react-redux';
import { Container, Content } from './style';
import screenWidthProvider from '../../Containers/HOCS/ScreenWidthProvider';
import { Switch, Route } from 'react-router-dom';
import Members from '../Members';
import { screenTypes } from '../../../Constants/screenTypes';
import MembershipTypes from './MembershipTypes';
import AdminPanelCalendar from './Calendar';
import { compose } from 'recompose';
import { MobileContainer } from './MobileContainer';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import AdminGymTv from './GymTv';
import GymTvChannelDisplay from './GymTv/ChannelDisplay';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';

class GymAdmin extends Component {
    componentDidMount() {
        const CURRENT_USER_ID = handleLoginService.getUserId();
        this.props.getAuthenticatedUser(CURRENT_USER_ID);
    }

    render() {
        const { match, screenWidth, logout, currentUser } = this.props;

        return screenWidth === screenTypes.DESKTOP ? (
            <Container>
                <SideMenu user={currentUser} onLogout={logout} />
                <Content>
                    <Switch>
                        <Route path={`${match.url}/membership-types`} component={MembershipTypes} />
                        <Route path={`${match.url}/calendar`} component={AdminPanelCalendar} />
                        <Route path={`${match.url}/gym-tv/:channelId`} component={GymTvChannelDisplay} />
                        <Route path={`${match.url}/gym-tv`} component={AdminGymTv} />
                        <Route path={`${match.url}`} component={Members} />
                    </Switch>
                </Content>
            </Container>
        ) : (
            <MobileContainer />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(UserActionCreators.logOutRequest({ device_id: 'somedeviceId' })),
    getAuthenticatedUser: () => dispatch(UserActionCreators.getAuthenticatedUserRequest()),
});

const mapStateToProps = ({ user: { currentUser } }) => ({
    currentUser,
});

export default compose(
    screenWidthProvider,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(GymAdmin);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/index.js